import { render, staticRenderFns } from "./ReportResult.vue?vue&type=template&id=6bb919ca"
import script from "./ReportResult.vue?vue&type=script&lang=js"
export * from "./ReportResult.vue?vue&type=script&lang=js"
import style0 from "./ReportResult.vue?vue&type=style&index=0&id=6bb919ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports